import StripeFields from './stripeFields';
import MoipFields from './moipFields';
import MercadoPagoFields from './mercadoPagoFields';

export const PaymentFields = ({ errors, setFieldError }) => {
  if(process.env.REACT_APP_PAYMENT_GATEWAY === 'moip'){
    return <MoipFields />;
  }
  else if(process.env.REACT_APP_PAYMENT_GATEWAY === 'stripe'){
    return <StripeFields errors={errors} setFieldError={setFieldError} />;
  }
  else if(process.env.REACT_APP_PAYMENT_GATEWAY === 'mercadopago'){
    return <MercadoPagoFields />;
  }
  else return null;
}

export default PaymentFields;
